import React, { useState, useEffect } from "react";
import styled from "styled-components";

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
`;

const PopupContent = styled.div`
  position: relative;
  background: white;
  width: 85%;
  max-width: 350px; // 이미지를 조금 더 컴팩트하게 조절
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);

  @media (min-width: 769px) {
    max-width: 450px;
  }
`;

const CloseIconButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.4);
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-size: 20px;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;

  &:hover {
    background: rgba(0, 0, 0, 0.6);
  }
`;

const ImageLink = styled.a`
  display: block;
  width: 100%;
  cursor: pointer;
`;

const PopupImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const PopupFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  background-color: #ffffff;
  gap: 8px;
`;

const CallInfoText = styled.div`
  font-size: 12px;
  color: #888;
`;

const FooterButton = styled.button`
  background: none;
  border: none;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #000;
  }
`;

const Popup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [popupImage, setPopupImage] = useState<string | null>(null);

  useEffect(() => {
    const hidePopupUntil = localStorage.getItem("hidePopupUntil");
    const today = new Date();
    const now = today.getTime();

    if (hidePopupUntil && now <= parseInt(hidePopupUntil)) {
      return;
    }

    setPopupImage("/image/popup/popup1.webp");
    setIsOpen(true);
  }, []);

  const closePopup = () => {
    setIsOpen(false);
  };

  const closeForADay = () => {
    const expiryDate = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem("hidePopupUntil", expiryDate.toString());
    setIsOpen(false);
  };

  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  const handlePopupClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const email = "joiemanager@joiesydney.com.au";
    if (isMobile()) {
      window.location.href = `mailto:${email}`;
    } else {
      window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${email}`, '_blank');
    }
  };

  if (!isOpen || !popupImage) return null;

  return (
    <PopupOverlay onClick={closePopup}>
      <PopupContent onClick={(e) => e.stopPropagation()}>
        {/* 우측 상단 닫기 X 버튼 */}
        <CloseIconButton onClick={closePopup}>&times;</CloseIconButton>

        {/* 이미지 클릭 시 조이매니저 이메일 연결 */}
        <ImageLink href="mailto:joiemanager@joiesydney.com.au" onClick={handlePopupClick}>
          <PopupImage
            src={process.env.PUBLIC_URL + popupImage}
            alt="Promotion Popup"
          />
        </ImageLink>

        <PopupFooter>
          <CallInfoText>Click image to send email to Joie Manager</CallInfoText>
          {/* 하단 하루 동안 보지 않기 버튼만 남김 */}
          <FooterButton onClick={closeForADay}>
            Don't show for a day
          </FooterButton>
        </PopupFooter>
      </PopupContent>
    </PopupOverlay>
  );
};

export default Popup;
